// Uses the "Extended_Pictographic" Unicode character class to indentify emojis.
// Related SO post: https://stackoverflow.com/questions/18862256/how-to-detect-emoji-using-javascript
const hasEmoji = (input: string) => input.match(/\p{Extended_Pictographic}/u);

export default hasEmoji;
